export default __webpack_public_path__ + "static/media/Print_Osmart_Logo.dd147c24.jpg";